/* Aura Exit-Intent Popup — JS */
(function () {
  'use strict';

  var STORAGE_KEY = 'aura_exit_popup_shown';
  var ARM_DELAY_MS = 4000;       // wait before exit intent can trigger
  var MOBILE_DELAY_MS = 25000;   // touch devices: show after 25s on site
  var EXIT_THRESHOLD = 5;

  function init() {
    var overlay = document.getElementById('aura-exit-popup-overlay');
    if (!overlay) return;

    var closeBtn = overlay.querySelector('.aura-exit-popup-close');
    var successMsg = overlay.querySelector('.aura-exit-popup-success');
    var armed = false;
    var shownThisPage = false;

    function lockScroll(lock) {
      document.body.style.overflow = lock ? 'hidden' : '';
    }

    function showPopup(force) {
      if (shownThisPage) return;
      if (!force && sessionStorage.getItem(STORAGE_KEY)) return;
      shownThisPage = true;
      sessionStorage.setItem(STORAGE_KEY, '1');
      overlay.classList.add('is-visible');
      overlay.setAttribute('aria-hidden', 'false');
      lockScroll(true);
      var emailInput = overlay.querySelector('input[type="email"]');
      if (emailInput && !force) setTimeout(function () { emailInput.focus(); }, 300);
    }

    function hidePopup() {
      overlay.classList.remove('is-visible');
      overlay.setAttribute('aria-hidden', 'true');
      lockScroll(false);
    }

    if (closeBtn) closeBtn.addEventListener('click', hidePopup);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) hidePopup(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-visible')) hidePopup();
    });

    // After a successful signup Shopify reloads the page — confirm it to the shopper.
    if (successMsg && successMsg.classList.contains('is-visible') && /customer_posted=true/.test(location.search)) {
      showPopup(true);
      setTimeout(hidePopup, 5000);
      return;
    }

    if (sessionStorage.getItem(STORAGE_KEY)) return;

    setTimeout(function () { armed = true; }, ARM_DELAY_MS);

    // Desktop: cursor leaves toward the browser bar
    document.addEventListener('mouseleave', function (e) {
      if (armed && e.clientY <= EXIT_THRESHOLD) showPopup();
    });

    // Scroll-up after reading half the page. The theme scrolls inside
    // .page-wrapper, so listen there as well as on window.
    var scroller = document.querySelector('.page-wrapper');
    var lastY = 0;
    function onScroll(el) {
      return function () {
        if (!armed) return;
        var y = el === window ? window.scrollY : el.scrollTop;
        var h = el === window ? document.documentElement.scrollHeight : el.scrollHeight;
        if (y / h > 0.5 && y < lastY - 40) showPopup();
        lastY = y;
      };
    }
    window.addEventListener('scroll', onScroll(window), { passive: true });
    if (scroller) scroller.addEventListener('scroll', onScroll(scroller), { passive: true });

    // Touch devices have no exit intent — use a gentle timer instead.
    if (window.matchMedia('(hover: none)').matches) {
      setTimeout(showPopup, MOBILE_DELAY_MS);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
